import axios from 'axios';

export default axios.create({
  baseURL: 'https://secure.webbookingpro.com/api/pms.php', //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
